import * as Yup from 'yup'

export const createValidationSchema = (fields) => {
  const schemaFields = {}
  
  fields.forEach(field => {
    let validator = Yup.string()
    
    if (field.required) {
      validator = validator.required(field.requiredMessage || 'This field is required')
    }
    
    if (field.type === 'email') {
      validator = validator.email('Please enter a valid email')
    }
    
    if (field.minLength) {
      validator = validator.min(field.minLength, `Minimum ${field.minLength} characters required`)
    }
    
    if (field.maxLength) {
      validator = validator.max(field.maxLength, `Maximum ${field.maxLength} characters allowed`)
    }
    
    if (field.pattern) {
      validator = validator.matches(field.pattern, field.patternMessage || 'Invalid format')
    }
    
    schemaFields[field.name] = validator
  })
  
  return Yup.object().shape(schemaFields)
}

export const validateCEP = (cep) => {
  const cepPattern = /^\d{5}-?\d{3}$/
  return cepPattern.test(cep)
}

export const validateDate = (date, format = 'DD/MM/YYYY') => {
  if (!date) return false
  
  const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/
  const match = date.match(datePattern)
  
  if (!match) return false
  
  const day = parseInt(match[1], 10)
  const month = parseInt(match[2], 10)
  const year = parseInt(match[3], 10)
  
  const dateObj = new Date(year, month - 1, day)
  
  return dateObj.getFullYear() === year &&
         dateObj.getMonth() === month - 1 &&
         dateObj.getDate() === day
}